import * as $ from 'jquery';
import 'bootstrap';
import Glide from '@glidejs/glide';

function init () {
  const carousel = new Glide('.glide-banner', { hoverpause: true, autoplay: 3000 }).mount();
  const slideFacebook = new Glide('.glide', { hoverpause: true }).mount();
  const slideWhatsapp = new Glide('.glide-whatsapp', { hoverpause: true }).mount();
  const slideInstagram = new Glide('.glide-instagram', { hoverpause: true }).mount();

  $('a[animate-click]').on('click', function(event) {
    if (this.hash !== "") {
      event.preventDefault();

      const hash = this.hash;

      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
        window.location.hash = hash;
      });
    }
  });
}

export default init()
